<template>
    <div class="post-op-viewer">
        <a-tabs>
            <a-tab-pane key="details" tab="Post Operation Detail">
                <div class="post-op-sections">
                    <div class="post-op-section">
                        <h3 class="section-title">General Information</h3>
                        <div class="field-group">
                            <div class="field">
                                <label><i class="material-icons">event_available</i>Status</label>
                                <div class="value">{{ postOp.Operation_Statu }}</div>
                            </div>
                            <div class="field">
                                <label><i class="material-icons">person</i>Owner</label>
                                <div class="value">{{ $_.get(postOp, "Owner.name", "") }}</div>
                            </div>
                            <div class="field">
                                <label><i class="material-icons">event</i>Operation Date</label>
                                <div class="value">{{ formatDate(postOp.Operation_Date) }}</div>
                            </div>
                            <div class="field">
                                <label><i class="material-icons">contacts</i>Contact</label>
                                <div class="value">{{ $_.get(postOp, "Contact.name", "") }}</div>
                            </div>
                            <div class="field">
                                <label><i class="material-icons">person</i>Name</label>
                                <div class="value">{{ postOp.Name }}</div>
                            </div>
                            <div class="field">
                                <label><i class="material-icons">wc</i>Gender</label>
                                <div class="value">{{ postOp.Cinsiyet }}</div>
                            </div>
                            <div class="field">
                                <label><i class="material-icons">phone</i>Phone</label>
                                <div class="value">{{ postOp.Phone }}</div>
                            </div>
                            <div class="field">
                                <label><i class="material-icons">email</i>Email</label>
                                <div class="value">{{ postOp.Email1 }}</div>
                            </div>
                            <div class="field">
                                <label><i class="material-icons">local_hospital</i>Planted Area</label>
                                <div class="value">{{ postOp.Ekim_B_lgesi.join(", ") }}</div>
                            </div>
                            <div class="field">
                                <label><i class="material-icons">comment</i>Comment Owner</label>
                                <div class="value">{{ $_.get(postOp, "Yorum_Sahibi.name", "") }}</div>
                            </div>
                            <div class="field">
                                <label><i class="material-icons">link</i>Comment Link</label>
                                <div class="value">
                                    <a :href="postOp.Yorum_Link_i" target="_blank">{{ postOp.Yorum_Link_i }}</a>
                                </div>
                            </div>
                            <div class="field">
                                <label><i class="material-icons">event</i>Comment Date</label>
                                <div class="value">{{ formatDate(postOp.Yorum_Tarihi) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </a-tab-pane>
            <a-tab-pane key="tasks" tab="Tasks">
                <Tasks :module="'Post_Operations'" :id="postOp.id" />
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
import Vue from "vue";
import Tasks from "./Tasks.vue";

export default Vue.extend({
    name: "PostOpViewer",
    components: {
        Tasks,
    },
    props: {
        postOp: {
            type: Object,
            required: true,
        },
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return "";
            return new Date(dateString).toLocaleDateString("tr-TR", {
                year: "numeric",
                month: "long",
                day: "numeric",
            });
        },
    },
});
</script>

<style scoped lang="scss">
.post-op-viewer {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .post-op-sections {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .post-op-section {
        .section-title {
            font-weight: 600;
            font-size: 16px;
            color: #2d3748;
            margin-bottom: 16px;
            padding-bottom: 8px;
            border-bottom: 1px solid #e2e8f0;
        }

        .field-group {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;

            .field {
                label {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 13px;
                    color: #64748b;
                    margin-bottom: 4px;

                    i {
                        font-size: 16px;
                    }
                }

                .value {
                    font-size: 14px;
                    color: #1a202c;
                }
            }
        }
    }
}
</style>
